import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'
import { Button, Modal, Table, Label, Pagination, Item, Header, Segment } from 'semantic-ui-react'
import firebase from '../../config/firebase'
import Loading from '../../components/common/loading'
import RealTimeTracker from '../../components/common/tracker'
import OrderRow from '../orders/components/OrderListItem'

import DriverActions from '../../reducers/driverReducer'
import DelivereeActions from '../../reducers/delivereeReducer'

const numberPerPage = 25

class DelivereeOrder extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      orders: [],
      numberOfPages: 1,
      modalOrderDetailVisible: false,
    }

    this.orderRef = firebase
      .database()
      .ref('orders')
      .orderByChild('deliveree')
      .equalTo(props.location.state.uid)
  }

  componentDidMount() {
    const { driverLoaded, syncDrivers, deliverees, location, getDeliveree } = this.props
    const { uid } = location.state

    const self = this

    if (!deliverees[uid]) {
      getDeliveree(uid)
    }

    if (!driverLoaded) {
      syncDrivers()
    }

    this.setState({ loading: true })

    try {
      this.orderRef.on('value', snapshot => {
        self.setState({ loading: false }, () => {
          self.setOrders(snapshot)
        })
      })
    } catch (error) {
      alert(error)
      this.setState({ loading: false })
    }
  }

  componentWillUnmount() {
    this.orderRef.off()
  }

  onViewDetailClick = viewOrder => {
    this.setState({
      modalOrderDetailVisible: true,
      viewOrder,
    })
  }

  handlePaginationChange = (e, { activePage }) => this.setState({ currentPage: activePage })

  setOrders = orderSnapshot => {
    let orderArr = []

    orderSnapshot.forEach(data => {
      orderArr.push({
        ...data.val(),
        key: data.key,
      })
    })

    orderArr = _.orderBy(orderArr, ['created_at'], ['desc'])

    const pageSize = Math.ceil(_.size(orderArr) / numberPerPage)

    this.setState({
      orders: orderArr,
      numberOfPages: pageSize,
      currentPage: 1,
    })
  }

  getLabelColor = status => {
    switch (status) {
      case 'confirmed':
        return 'yellow'
      case 'drivers_not_available':
        return 'yellow'
      case 'outForDelivery':
        return 'yellow'
      case 'rejected':
        return 'red'
      case 'delivered':
        return 'green'
      default:
        return 'gray'
    }
  }

  getLabel = status => {
    switch (status) {
      case 'confirmed':
        return 'Confirmed'
      case 'drivers_not_available':
        return 'Confirmed'
      case 'outForDelivery':
        return 'Out for delivery'
      case 'rejected':
        return 'Rejected'
      case 'delivered':
        return 'Delivered'
      default:
        return _.capitalize(status)
    }
  }

  getOrderItems = order => {
    return _.sum(_.map(order.items, item => item.quantity))
  }

  renderEachRow = (id, order) => {
    return (
      <Item key={order.key}>
        <Item.Content>
          <Item.Header>
            {id}. {order.restaurant.name} - {order.restaurant.branch.name}
          </Item.Header>
          <Item.Meta>Created: {moment(order.created_at).format('DD-MMM-YYYY hh:mm a')}</Item.Meta>
          <Item.Extra>
            <Label style={{ marginRight: 10 }} size="tiny">
              {this.getOrderItems(order)} Items
            </Label>
            {
              <Label size="tiny" color={this.getLabelColor(order.status)} style={{ marginRight: 10 }}>
                {this.getLabel(order.status)}
              </Label>
            }
            {
              <Label style={{ cursor: 'pointer' }} size="tiny" onClick={() => this.onViewDetailClick(order)}>
                View Detail
              </Label>
            }
          </Item.Extra>
        </Item.Content>
      </Item>
    )
  }

  renderRows = () => {
    const { currentPage, orders } = this.state

    const begin = (currentPage - 1) * numberPerPage
    const end = begin + numberPerPage

    if (_.size(orders) > 0) {
      const pageList = _.slice(orders, begin, end)

      let id = begin
      const driverRows = _.map(pageList, order => {
        id += 1

        return this.renderEachRow(id, order)
      })

      return (
        <Item.Group style={{ width: '100%' }} divided>
          {driverRows}
        </Item.Group>
      )
    }

    return null
  }

  convertToCurrent = amount => `$ ${Number(parseFloat(amount).toFixed(2))}`

  render() {
    const { viewOrder, modalOrderDetailVisible, orders, loading, currentPage, numberOfPages } = this.state

    const { driverLoading, location, deliverees } = this.props
    const uid = location.state && location.state.uid
    const deliveree = deliverees[uid]
    const createdAt = deliveree && deliveree.created_at

    const successOrders = orders.filter(order => order.status === 'delivered')
    const orderCount = orders.length
    const successOrderCount = successOrders.length

    const spending = orders.reduce((result, order) => {
      result.deliveryFee += order.delivery_fee
      result.subTotal += order.sub_total
      result.commission += order.sub_total * order.discount_rate / 100

      return result
    }, { deliveryFee: 0, subTotal: 0, commission: 0 })

    return (
      <div>
        <div className='ui equal width grid'>
          <div className='column'>
            <RealTimeTracker
              label="Orders"
              icon="shop"
              loaded
              actualValue={orderCount}
            />
          </div>
          <div className='column'>
            <RealTimeTracker
              label="Success Orders"
              icon="shop"
              loaded
              actualValue={successOrderCount}
            />
          </div>
          <div className='column'>
            <RealTimeTracker
              label="Joined on"
              icon="history"
              loaded
              actualValue={createdAt ? moment(createdAt).format('DD-MM-YYYY') : 'N/A'}
            />
          </div>
        </div>
        <div className='ui equal width grid'>
          <div className='column' style={{ paddingTop: 0 }}>
            <RealTimeTracker
              label="Spending"
              icon="money"
              loaded
              actualValue={this.convertToCurrent(spending.subTotal + spending.deliveryFee)}
            />
          </div>
          <div className='column' style={{ paddingTop: 0 }}>
            <RealTimeTracker
              label="Profit"
              icon="money"
              loaded
              actualValue={this.convertToCurrent(spending.commission + (spending.deliveryFee * 0.25))}
            />
          </div>
        </div>
        <Segment>
          <Loading active={loading || driverLoading} />
          <Header>Orders</Header>
          <div
            style={{
              display: 'flex',
              flex: 1,
              height: 'calc(100vh - 220px)',
              overflow: 'auto',
            }}
            className="list-user-orders"
          >
            {this.renderRows()}
          </div>
          <div style={{ marginTop: 14, textAlign: 'right' }}>
            {_.size(orders) > 0 && (
              <Pagination
                activePage={currentPage}
                onPageChange={this.handlePaginationChange}
                totalPages={numberOfPages}
              />
            )}
          </div>
          <Modal
            open={modalOrderDetailVisible}
            style={{ marginTop: 0, width: '90vw' }}
            closeOnEscape={false}
            closeOnDimmerClick={false}
          >
            <Modal.Header>Order Detail</Modal.Header>
            <Modal.Content style={{ padding: 0 }}>
              <Segment style={{ padding: 0, boxShadow: 'none', border: '0px', minHeight: 50 }}>
                {viewOrder && (
                  <Table basic style={{ marginTop: 0 }}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell style={{ width: '12%' }}>Customer</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '15%' }}>Resturant</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '25%' }}>Items</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '13%' }} textAlign="center">
                          Payment
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '10%' }} textAlign="center">
                          Driver
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '10%' }} textAlign="center">
                          Ordered at
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '15%' }} textAlign="center">
                          Status/Actions
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <OrderRow key={viewOrder.key} order={viewOrder} readOnly />

                      {/* <OrderRow key={viewOrder.key} data={viewOrder} screen="driver" /> */}
                    </Table.Body>
                  </Table>
                )}
              </Segment>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={() => this.setState({ modalOrderDetailVisible: false, viewOrder: null })}>
                Close
              </Button>
            </Modal.Actions>
          </Modal>
        </Segment>
      </div>
    )
  }
}

const mapState = ({ drivers, deliverees }) => ({
  driverLoaded: drivers.driverLoaded,
  driverLoading: drivers.driverLoading,

  deliverees: deliverees.data,
})

const mapDispatch = {
  syncDrivers: DriverActions.syncDrivers,
  getDeliveree: DelivereeActions.getDeliveree,
}

export default connect(
  mapState,
  mapDispatch
)(DelivereeOrder)



// WEBPACK FOOTER //
// ./src/containers/deliverees/delivereeOrder.js